import { Component, OnInit, Inject } from '@angular/core';
import { environment } from 'src/environments/environment';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CommonService } from 'src/app/services/common.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-requirements-bank-details',
  templateUrl: './requirements-bank-details.component.html',
  styleUrls: ['./requirements-bank-details.component.scss'],
})
export class RequirementsBankDetailsComponent implements OnInit {
  RESOURCE_SERVER_URL = environment.RESOURCE_SERVER_URL;
  isLoading: boolean = false;
  searchicon =
    this.RESOURCE_SERVER_URL +
    '/assets/images/Underwriting_new/Header/Search.svg';
  addIcon =
    this.RESOURCE_SERVER_URL +
    '/assets/images/Claim_Office/Beneficiary_Requirements/Add_Purple.svg';
  bankACDetails: boolean = true;
  paymentDetails: boolean = false;
  newBankDetails: boolean = false;
  paymentTypeKey: any;
  outSourceChequeFlag: boolean = false;
  preDefinedChequeFlag: boolean = false;
  bankAccountDetailsFlag: boolean = false;
  claimId: any;
  policyID: any;
  beneficiaryId: any;
  paymentTypeDetails: any;
  bankPaymentDetails: any = {};
  enableCreateNewBankDetails: boolean = false;
  factoringHouseList: any;
  accountCurrencyList: any;
  accountTypeList: any;
  beneficiaryNumber: any;
  beneficiaryFirstName: any;
  beneficiaryLastName: any;
  getBankData: any;
  createNewBankData = {
    bankKey: '',
    currcode: '',
    bankAccountType: '',
    dateFrom: '',
    facthous: '',
    dattoDisp: '',
    bankAccount: '',
    ibanaccno: '',
    sctycde: '',
    bankAccountDec: '',
  };

  constructor(
    private commonService: CommonService,
    private dialogRef: MatDialogRef<RequirementsBankDetailsComponent>,
    private route: ActivatedRoute,
    private router: Router,
    @Inject(MAT_DIALOG_DATA) public data
  ) {}

  ngOnInit(): void {
    this.claimId = this.data.claimID;
    this.policyID = this.data.policyId;
    this.beneficiaryId = this.data.beneficiaryId;
    this.beneficiaryNumber = this.data.beneficiaryNumber;
    this.beneficiaryFirstName = this.data.beneficiaryFirstName;
    this.beneficiaryLastName = this.data.beneficiaryLastName;
    this.onGetPaymentType();
  }

  async getAllBankDetails() {
    this.isLoading = true;
    try {
      let url =
        environment.API_CONFIG_URL +
        'claimsOffice/claims/' +
        this.claimId +
        '/policy/' +
        this.policyID +
        '/beneficiary/' +
        this.beneficiaryId +
        '/bankAccount';
      let response = await this.commonService.commonGet(url);
      this.getBankData = response.body._links.item;
      this.isLoading = false;
    } catch (err) {
      console.log('Get API - Get all bank account Error.', err);
      this.isLoading = false;
    }
  }

  onDataInput(event, key) {
    if (key == 'O') {
      this.outSourceChequeFlag = event;
      if (event) {
        this.paymentTypeDetails.paymentTypeKey = 'O';
        this.preDefinedChequeFlag = false;
        this.bankAccountDetailsFlag = false;
      } else {
        this.paymentTypeDetails.paymentTypeKey = '';
        this.outSourceChequeFlag = false;
      }
    } else if (key == 'P') {
      this.preDefinedChequeFlag = event;
      if (event) {
        this.paymentTypeDetails.paymentTypeKey = 'P';
        this.outSourceChequeFlag = false;
        this.bankAccountDetailsFlag = false;
      } else {
        this.paymentTypeDetails.paymentTypeKey = '';
        this.preDefinedChequeFlag = false;
      }
    } else if (key == 'D') {
      this.bankAccountDetailsFlag = event;
      if (event) {
        this.paymentTypeDetails.paymentTypeKey = 'D';
        this.outSourceChequeFlag = false;
        this.preDefinedChequeFlag = false;
      } else {
        this.paymentTypeDetails.paymentTypeKey = '';
        this.bankAccountDetailsFlag = false;
      }
    }
    console.log('paymentType', this.paymentTypeDetails.paymentTypeKey);
  }

  onCloseDialog() {
    this.dialogRef.close();
  }

  async openBankDetails() {
    await this.getAllBankDetails();
    this.bankACDetails = false;
    this.paymentDetails = true;
    this.newBankDetails = false;
  }

  createNewBankDetails() {
    this.bankACDetails = false;
    this.paymentDetails = false;
    this.newBankDetails = true;
  }

  async onSaveNewBankDetails() {
    this.isLoading = true;
    this.createNewBankData.bankKey = this.bankPaymentDetails.bankKey;
    this.createNewBankData.facthous = this.bankPaymentDetails.facthous;
    this.createNewBankData.bankAccount = this.bankPaymentDetails.bankAccount;
    this.createNewBankData.bankAccountDec =
      this.bankPaymentDetails.bankAccountDec;
    this.createNewBankData.bankAccountType =
      this.bankPaymentDetails.bankAccountType;
    this.createNewBankData.sctycde = this.bankPaymentDetails.sctycde;
    this.createNewBankData.currcode = this.bankPaymentDetails.currcode;
    this.createNewBankData.dateFrom = this.bankPaymentDetails.dateFrom;
    this.createNewBankData.dattoDisp = this.bankPaymentDetails.dattoDisp;
    this.createNewBankData.ibanaccno = this.bankPaymentDetails.ibanaccno;

    console.log('Bank Details: ', this.createNewBankData);
    let body = this.createNewBankData;
    let headers = this.commonService.getHeaders();
    try {
      let url =
        environment.API_CONFIG_URL +
        'claimsOffice/claims/' +
        this.claimId +
        '/policy/' +
        this.policyID +
        '/beneficiary/' +
        this.beneficiaryId +
        '/bankAccount/submit';
      let response = await this.commonService.commonPost(url, body, headers);
      console.log('Response: ', response.body);
      this.onCloseNewBankDetails();
      this.isLoading = false;
    } catch (err) {
      console.log('Post API - Creation of new bank account Error.', err);
      this.isLoading = false;
    }
  }

  onCloseNewBankDetails() {
    this.bankACDetails = false;
    this.paymentDetails = true;
    this.newBankDetails = false;
  }

  async onGetPaymentType() {
    this.isLoading = true;
    try {
      let url =
        environment.API_CONFIG_URL +
        'claimsOffice/claims/' +
        this.claimId +
        '/policy/' +
        this.policyID +
        '/beneficiary/' +
        this.beneficiaryId;
      let response = await this.commonService.commonGet(url);
      this.paymentTypeDetails = response.body;
      // Assign the paymentTypeKey directly from the response
      this.paymentTypeKey = this.paymentTypeDetails.paymentTypeKey;

      // Update flags based on the received paymentTypeKey
      this.outSourceChequeFlag = this.paymentTypeKey === 'O';
      this.preDefinedChequeFlag = this.paymentTypeKey === 'P';
      this.bankAccountDetailsFlag = this.paymentTypeKey === 'D';
      this.isLoading = false;
    } catch (err) {
      console.log('Get API - On Payment Type Error.', err);
      this.isLoading = false;
    }
  }

  async onSavePaymentType() {
    this.isLoading = true;
    let payload = { paymentTypeKey: this.paymentTypeDetails.paymentTypeKey };
    try {
      let url =
        environment.API_CONFIG_URL +
        'claimsOffice/claims/' +
        this.claimId +
        '/policy/' +
        this.policyID +
        '/beneficiary/' +
        this.beneficiaryId;
      await this.commonService.commonPatch(url, payload);
      this.onCloseDialog();
      this.isLoading = false;
    } catch (err) {
      console.log('Patch API - On Payment Type Error.', err);
      this.isLoading = false;
    }
  }

  onDataInputPaymentDetails(event, key) {
    this.bankPaymentDetails[key] = event;
  }

  async onCreateBankDetails() {
    this.isLoading = true;
    let payload = { bankKey: this.bankPaymentDetails.bankKey };
    try {
      let url =
        environment.API_CONFIG_URL +
        'claimsOffice/claims/' +
        this.claimId +
        '/getBankBranchList?page=0&size=5';
      let response = await this.commonService.commonPost(url, payload);
      this.commonService.bankPaymentDetails = response.body.result.listClass[0];
      console.log('getBankDetails:::', this.commonService.bankPaymentDetails);
      this.bankPaymentDetails.bankdesc =
        this.commonService.bankPaymentDetails.bankdesc;
      this.bankPaymentDetails.branchdesc =
        this.commonService.bankPaymentDetails.branchdesc;
      if (this.commonService.bankPaymentDetails.facthous != null)
        this.bankPaymentDetails.facthous =
          this.commonService.bankPaymentDetails.facthous.toString();
      console.log('factoringHouse::', this.bankPaymentDetails.facthous);
      this.bankPaymentDetails.client = this.beneficiaryNumber;
      this.bankPaymentDetails.clientName =
        this.beneficiaryFirstName + ' ' + this.beneficiaryLastName;
      if (this.bankPaymentDetails.bankKey != '') {
        this.enableCreateNewBankDetails = true;
      }
      await this.initialDropdown(this.bankPaymentDetails.bankKey);
      this.isLoading = false;
    } catch (err) {
      console.log('Patch API - On Payment Type Error.', err);
      this.isLoading = false;
    }
  }

  async initialDropdown(data) {
    this.isLoading = true;
    try {
      let url =
        environment.API_CONFIG_COMMON +
        'lookup?list=accountType,currencyCodeDetails,factHouse';
      let response = await this.commonService.commonGet(url);
      this.factoringHouseList = response.body.factHouse;
      this.accountTypeList = response.body.accountType;
      this.accountCurrencyList = response.body.currencyCodeDetails;
      this.isLoading = false;
    } catch (err) {
      console.log(
        'Get API Error - Initial Dropdown for Requirement Bank Detail.',
        err
      );
      this.isLoading = false;
    }
  }
}
